module.exports = __webpack_public_path__ + "static/media/teapot_thumbnail.acea94d9.png";